// VersionBadge.jsx — v119.220 شارة نسخة دائمة صغيرة أسفل الشاشة.
// أي لقطة شاشة من أي موظف تكشف فوراً أي نسخة يشغّلها جهازه.
import React from "react";
import { APP_VERSION } from "./lib/version";

export default function VersionBadge() {
  return (
    <div className="tw-version-badge" data-testid="version-badge">
      {APP_VERSION}
    </div>
  );
}
